import { parseCalendarDay } from './localDate';
/**
 * Subscription Helper Functions
 * Single Responsibility: Provide utility functions for subscription data formatting
 */

/**
 * Format currency value
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount || 0);
};

/**
 * Format date value
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

/**
 * Get subscription summary text
 */
export const getSubscriptionSummary = (subscription) => {
  if (!subscription || !subscription.subscription_status) {
    return 'No subscription';
  }

  const parts = [];
  if (subscription.plan_name) {
    parts.push(subscription.plan_name.charAt(0).toUpperCase() + subscription.plan_name.slice(1));
  }
  if (subscription.monthly_price) {
    parts.push(formatCurrency(subscription.monthly_price));
  }
  if (subscription.subscription_status) {
    parts.push(`(${subscription.subscription_status})`);
  }

  return parts.join(' - ');
};

/**
 * Check if subscription is active
 */
export const isSubscriptionActive = (subscription) => {
  return subscription?.subscription_status === 'active' || subscription?.subscription_status === 'trial';
};

/**
 * Check if subscription is expired
 */
export const isSubscriptionExpired = (subscription) => {
  if (!subscription?.current_period_end) return false;
  return parseCalendarDay(subscription.current_period_end) < new Date();
};

